// eslint-disable-next-line
export default {
  title: "default",

  colors: {
    black: "#000",
    primary: "#734DFF",
    primary02: "#623CEA",
    blue: "#5A67DF",
    blue7: "#1C7ED6",
    gray: "#8C8A97",
    gray00: "#F8F9FA",
    gray01: "#33303E",
    gray02: "#4E4B59",
    gray03: "#5F5C6B",
    gray05: "#8C8A97",
    gray07: "#495057",
    gray08: "#E9ECEF",
    
    secondaryBlue: "#3B5BDB",
    
    
    white: "#FFFf",
    white01: "#F1F3F5",
    

    success: "#44E4E4",
    error: "#F64F77",
    warning: "#F8AE3F",
  },
};
